import { useState, useEffect } from 'react'

import Page from '@/Page.jsx'
import { api, useUser, titleCase } from '@/common'

import ButtonAppAdd from '@/ButtonAppAdd.jsx'
import ButtonTermAdd from '@/ButtonTermAdd.jsx'
import ButtonAppDelete from '@/ButtonAppDelete.jsx'
import ButtonTermDelete from '@/ButtonTermDelete.jsx'
import ButtonAppReport from '@/ButtonAppReport.jsx'
import ButtonUpdate from '@/ButtonUpdate.jsx'

function ShowChartRank({ id }) {
  const [rankText, rankTextSet] = useState([])

  useEffect(() => {
    if (id) {
       api.get(`/charts/${id}`).then(r => rankTextSet(r))
    }
  }, [id])

  return rankText.map((m, i) => <div key={i}>{`#${m.position+1} in ${titleCase(m.population)} ${titleCase(m.category)}`}</div>)
}


function TabList() {
  const [apps, appsSet] = useState([])
  const [user] = useUser()

  const updateApps = async () => {
    appsSet(await api.get('/app'))
  }

  useEffect(() => {
    if (user) {
      updateApps()
    }
  }, [user])

  return (
    <>
    <div className='flex flex-row gap-2'>
      <ButtonAppAdd className='btn-primary' onSubmit={updateApps} />
      {!!apps?.length && (<ButtonTermAdd className='btn-secondary' apps={apps} onSubmit={updateApps} />)}
      {!!apps?.length && (<ButtonAppReport className='btn-accent'>Get Report for All</ButtonAppReport>)}
    </div>
    <div className='flex flex-col gap-2 mt-2'>
      {apps.map((app, i) => (
        <div key={i} tabIndex={i} className='collapse collapse-arrow border border-base-300 p-4 bg-neutral'>
          <input type="checkbox" />
          <div className='flex flex-row gap-2 items-center collapse-title pl-0  font-semibold'>
            <img src={app.icon} alt={app.title} className='w-8' />
            <span>{app.title} ({app.country} / {app.language})</span>
          </div>
          <div className='flex gap-2 flex-row'>
            <ButtonTermAdd title={`Add terms to ${app.title}`} className='btn-outline btn-secondary btn-circle' onSubmit={updateApps} apps={[app]} children='' />
            <ButtonAppDelete app={app} className='btn-outline btn-circle btn-error' onSubmit={updateApps} />
            <ButtonAppReport app={app} className='btn-outline btn-circle btn-accent' />
          </div>
          <div className='text-sm collapse-content'>
            <div>App Store: <a className='link' href={`https://apps.apple.com/${app.country.toLowerCase()}/app/id${app.store_id}?l=${app.language.split('_')[0]}`}>{app.store_id}</a></div>
            {/*<div>Gummicube: {app.id}</div>*/}
            <ShowChartRank id={app.id} />
            {!!app.terms?.length && (
              <table className='table table-zebra mt-2'>
                <thead>
                  <tr>
                    <th>Term</th>
                    <th>Rank</th>
                    <th>Last Searched</th>
                    <th />
                  </tr>
                </thead>
                <tbody>
                  {app.terms.map((t, i) => (
                    <tr key={i} className='hover'>
                      <td>{t.term}</td>
                      <td>{t.position}</td>
                      <td>{t.date}</td>
                      <td className='flex'>
                        <ButtonTermDelete app={app} term={t} onSubmit={updateApps} className='btn-circle hover:btn-error btn-sm' />
                        <ButtonUpdate className='btn-circle hover:btn-success btn-sm' app={app} term={t} onSubmit={updateApps} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      ))}
    </div>
  </>
  )
}


export default function PageList () {
  return (
    <Page>
      <TabList />
    </Page>
  )
}
